import { pluralise } from "modules/utils";
import type { DurationValue } from "./DurationField";

export const durationLabel = ({ num, unit, indefinite }: DurationValue) =>
  indefinite
    ? "Indefinite"
    : `${num} ${pluralise(unit.replace(/s$/, ""), num)}`;
